import { Component, OnInit } from '@angular/core';
import { DatesService } from '@infrastructure/services/alpura/dates.service';
import { PlantasService } from 'app/infrastructure/services/catalog/plantas.service';
import {
  FormBuilder,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { OtherService } from 'app/infrastructure/services/catalog/otros.service';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ReversaLiquidacionService } from 'app/infrastructure/services/captura/reversa-liquidacion.service';
import { LoaderService } from '@infrastructure/shared/theme/loader/loader.service';
import { UtilInformationService } from '../../../services/utils/dates.service';

export interface ResultData {
  message: string;
  code: string;
  isSuccess: boolean;
}

@Component({
  selector: 'app-autoriza-liquidaciones',
  templateUrl: './autoriza-liquidaciones.component.html',
  styleUrls: ['./autoriza-liquidaciones.component.scss'],
  providers: [OtherService],
})
export class AutorizaLiquidacionesComponent implements OnInit {
  public panelInfo: any = {};
  listaPlantas: any[] = [];

  guardarFG: FormGroup = this.formBuilder.group({
    idCmbPlanta: ['', [Validators.required]],
    idEstado: ['', [Validators.required]],
    idEjercicio: ['', [Validators.required]],
    idSemana: ['', [Validators.required]],
    diaInicio: ['', []],
    diaFin: ['', []],
  });

  listaEstados: any[] = [];

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private _datesService: DatesService,
    public _other: OtherService,
    private plantasService: PlantasService,
    private loader: LoaderService,
    private servicioReversa: ReversaLiquidacionService,
    private utilInformationService: UtilInformationService
  ) {
    this.setDates();

    this.guardarFG.get('idEjercicio')?.valueChanges.subscribe((val) => {
      if (val) {
        this.panelInfo.year = val;
        this.updateDates();
      }
    });

    this.guardarFG.get('idSemana')?.valueChanges.subscribe((val) => {
      if (val) {
        this.panelInfo.week = val;
        this.updateDates();
      }
    });
  }

  ngOnInit(): void {
    this.obtenerPlantas();
    this.getListaEstados();
  }

  private setDates() {
    this._datesService.getCurrentDate().subscribe(
      async (resp: any) => {
        console.info('Mea getDate ', resp);
        this.panelInfo.currentDate = new Date(resp);
        this.panelInfo.year = new Date(resp).getFullYear();
        this._datesService.getCurrentWeek().subscribe(
          async (resp: any) => {
            console.info('Mea getWeek ', resp);
            this.panelInfo.week = resp;
            const idEjercicioControl = this.guardarFG.get('idEjercicio');
            const idSemanaControl = this.guardarFG.get('idSemana');

            if (idEjercicioControl) {
              idEjercicioControl.patchValue(this.panelInfo.year);
            }

            if (idSemanaControl) {
              idSemanaControl.patchValue(this.panelInfo.week);
            }
            this.updateDates();
          },
          (error) => {
            console.error('Error al invocar el servicio de fechas Week.');
          }
        );
      },
      (error) => {
        console.error('Error al invocar el servicio de fechas Week.');
      }
    );
  }

  public updateDates() {
    if (!!this.panelInfo.year && !!this.panelInfo.week) {
      this.utilInformationService
        .getDataFromDate(this.panelInfo.year, this.panelInfo.week)
        .subscribe(
          (response) => {
            const element = response;
            this.panelInfo.diaInicio = new Date(element.startDate)
              .toISOString()
              .slice(0, 10);
            this.panelInfo.diaFin = new Date(element.endDate)
              .toISOString()
              .slice(0, 10);
            this.guardarFG
              .get('diaInicio')
              ?.patchValue(this.panelInfo.diaInicio);
            this.guardarFG.get('diaFin')?.patchValue(this.panelInfo.diaFin);
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Ocurrió un error',
              text: `No se pudo recuperar las semanas`,
            });
          }
        );
    }
  }

  obtenerPlantas() {
    this.plantasService.findAllPlantas().subscribe((s: any) => {
      this.listaPlantas = s.filter((f: any) => f.facilityId != 10);
    });
  }

  getListaEstados() {
    this._other.catSearchSet('ALP_ESTADO_LIQUIDACION').subscribe(
      async (res: any) => {
        if (res.id == 0) {
          Swal.fire({
            icon: 'info',
            title: 'Otros Catalogos',
            html: `<em class='fa fa-info-circle'></em>&nbsp;` + res.message,
          });
        } else {
          this.listaEstados = res.valueSetDetailResponse;
          this.listaEstados = this.listaEstados.filter(
            (x) => x.cveValue == 'A' || x.cveValue == 'P' || x.cveValue == 'N'
          );
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Ocurrió un error',
          html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; Al obtener estados de liquidación`,
        });
      }
    );
  }

  autorizar() {
    const formData = this.guardarFG.value;
    const dataToSend = {
      ejercicio: formData.idEjercicio,
      semana: formData.idSemana,
      planta: +formData.idCmbPlanta,
      estado: formData.idEstado,
    };
    this.loader.setLoading(true, 'Generando cambio de estado de liquidación');
    this.servicioReversa.autorizaLiquidacion(dataToSend).subscribe(
      (resp) => {
        this.loader.setLoading(false);
        if (resp.isSuccess === true) {
          Swal.fire({
            icon: 'success',
            title: 'Exito',
            html: `<br><em class='fa fa-info-circle'></em>&nbsp; ${
              resp.message || 'Se ha actualizado el estado de la planta'
            }`,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Ocurrió un error',
            html: `<br><em class='fa fa-info-circle'></em>&nbsp; ${
              resp.message || 'La planta Delicias no está autorizada'
            }`,
          });
        }
      },
      (error) => {
        this.loader.setLoading(false);
        console.error('Error al hacer la petición: ', error);
        Swal.fire({
          icon: 'error',
          title: 'Ocurrió un error',
          html: `<br><em class='fa fa-info-circle'></em>&nbsp; ${
            error.error?.message || 'Error al intentar comunicarse con la API'
          }`,
        });
      }
    );
  }
}
